<template>
  <card-dashboard
    v-if="classesData"
    :title="$t('dashboard.class_in_progress', { length: classesData.total })"
  >
    <div class="px-6 slick-slider-carousel">
      <VueSlickCarousel v-bind="settings">
        <div
          class="px-2"
          v-for="(item, index) in classesData.classes"
          :key="item.subject + index"
        >
          <card-carousel :carouselTitle="item.subject.name">
            <p class="font-bold text-center truncate mx-auto">
              <router-link
                :to="{
                  name: class_router_names.detailPage,
                  params: { id: item.class_id }
                }"
                class="text-gray-700"
              >
                {{ item.name }}
              </router-link>
            </p>
            <p class="text-sm font-normal text-center">{{ getTime(item) }}</p>

            <!-- PROGRESS BAR -->
            <div
              class="flex items-center justify-between mt-7 font-medium status"
            >
              <span>{{ generateStatus(item.status) }}</span>
              <span>{{ getProgress(item) }}</span>
            </div>
            <div class="progress">
              <div class="bar" :style="{ width: getProgress(item) }"></div>
            </div>
            <!-- PROGRESS BAR -->

            <p class="text-sm font-normal truncate">
              {{ $t("dashboard.teacher") }}: {{ getTeacherName(item) }}
            </p>
          </card-carousel>
        </div>
      </VueSlickCarousel>
    </div>
  </card-dashboard>
</template>
<script>
import CardDashboard from "../../Components/CardDashboard";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import CardCarousel from "../../Components/CardCarousel";
import { SETTING_CAROUSEL } from "../../Components/settings-carousel-config";
import { class_router_names } from "@/routes/routes";
import { generateStatus } from "@/helpers/text-helper";

export default {
  name: "classes-in-progress-student",
  components: { CardCarousel, CardDashboard, VueSlickCarousel },
  props: ["classesData"],
  data() {
    return {
      settings: SETTING_CAROUSEL,
      class_router_names,
      generateStatus
    };
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.settings.slidesToShow = window.innerWidth < 1024 ? 1 : 3;
    },
    formatDate(date) {
      if (!date) return "null";
      return date.replaceAll("-", "/");
    },

    getTime(item) {
      if (!item.start_date && !item.end_date) return "null";
      return `${this.formatDate(item.start_date)} - ${this.formatDate(
        item.end_date
      )}`;
    },

    getProgress(item) {
      if (item.calendars.done === 0 || item.calendars.total === 0) return "0%";
      const progress = (item.calendars.done / item.calendars.total) * 100;
      return Math.round(progress) + "%";
    },

    getTeacherName(item) {
      return item.teacher?.users?.user_no_sql.full_name;
    }
  }
};
</script>
